var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_1396)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52783 0.839081C4.34117 0.839081 0.527832 4.20441 0.527832 7.05153C0.527832 9.18486 1.91272 11.0666 4.02205 12.1849L3.13494 15.4435C3.05583 15.7324 3.38383 15.9617 3.63539 15.7955L7.52605 13.2133C7.85405 13.2453 8.18828 13.264 8.52783 13.264C12.9456 13.264 16.5278 10.4826 16.5278 7.05153C16.5278 4.20441 12.9456 0.839081 8.52783 0.839081Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_1396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.527832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.55d570cc883fa35626a33b3e71658b14.svg";
export { ForwardRef as ReactComponent };